import Vue from 'vue'
import {mapActions, mapState} from "vuex";
// @ts-ignore
import Mark from 'mark.js'
import bookPageAudio from '@/services/bookPageAudio'
import challengePageAudio from '@/services/challengePageAudio'

const configToMark = {
    ignorePunctuation: ['.', ':', ';', ','],
    wildcards: 'enabled',
    accuracy: 'complementary',
    className: 'storyteller-mark',
    acrossElements: true,
    separateWordSearch: false,
    caseSensitive: true,
    diacritics: false,
}

const defaultVoice = {id: 1, name: 'Mia', voice_provider_id: 'Mia'}

let pageVoices = false;

const markJs = Vue.extend({
    data() {
        return {
            soundActive: false,
            textArray: [],
            pageTextAsArray: [],
            voices: [],
            defaultVoice: defaultVoice.voice_provider_id,
            instance: null,
            textMarks: [],
            loading: false,
            currentTime: null,
            isChallenge: false,
            isBook: false,
            readerSound: false,
            volume: 25,
            rate: 1,
        }
    },
    computed: {
        ...mapState({
            trackIndex: (state: any) => state.bookReading.trackIndex,
            book: (state: any) => state.bookReading.book,
            testId: (state: any) => state.challenge.testId,
            currentPage: (state: any) => state.bookReading.currentPage,
            currentChapter: (state: any) => state.bookReading.currentChapter,
            currentVoice: (state: any) => state.bookReading.currentVoice,
            challengePage: (state: any) => state.challenge.challengePage,
            activeNarration: (state: any) => state.bookReading.activeNarration,
            pageAudio: (state: any) => state.bookReading.pageAudio,
        }),
        isNarratorActive() {
            const vm: any = this;
            return vm.activeNarration
        },
    },
    watch: {
        currentTime(nValue) {
            const vm: any = this
            const parsedTime = parseFloat(nValue);
            // Detectar el formato de los datos
            const isPhraseFormat = vm.textMarks.some((mark: any) => mark.type === 'ssml');
            
            let found: boolean | any = false;
            let isFound = false;
            
            if (isPhraseFormat) {
              // Formato original: frases
              found = vm.textMarks.filter((i: any) => i.time < parseInt(nValue, 10));
              if (found.length) {
                const currentText = vm.textArray[vm.textMarks.indexOf(found[found.length - 1])];
                vm.mark(currentText);
                isFound = true;
              }
            } else {
                // Nuevo formato: palabras
                const comparedTime = parsedTime;
                vm.textMarks.forEach((mark:any) => {
                    const wordElement = document.getElementById(mark.value + '_p' + this.currentPage );
                    if(wordElement){
                        if ((mark.start*1000) <= comparedTime && comparedTime <= (mark.end*1000)) {
                            if (!wordElement.classList.contains('highlight-spoken-word')) wordElement.classList.add('highlight-spoken-word');

                            // Selecciona todos los elementos que tienen la clase especificada
                            const elements = document.querySelectorAll('.highlight-sentence');
                            
                            // Recorre todos los elementos y elimina la clase especificada
                            elements.forEach(element => element.classList.remove('highlight-sentence')) 
                            wordElement.parentElement?.classList.add('highlight-sentence')
                            // if element is last child remove parent class
                            if (wordElement.nextElementSibling == null) {
                                setTimeout(() =>wordElement.parentElement?.classList.remove('highlight-sentence'), 500)
                            }
                        } else {
                            wordElement.classList.remove('highlight-spoken-word');
                        }
                    }
                });

            }
        
            // Verificar si el audio está pausado
            if (isFound && vm.pageAudio.paused) {
              vm.mark();
              vm.setActiveNarration(false);
              vm.readerSound = false;
            }
        },
        volume(nValue = 25) {
            const vm: any = this
            if (vm.pageAudio) vm.pageAudio.volume = nValue / 100
        },
        rate(nValue = 1) {
            const vm: any = this
            if (vm.pageAudio) vm.pageAudio.playbackRate = nValue
        },
        async currentPage(newCurrentPage) {
            const vm: any = this
            if (vm.pageAudio) {
                const {paused} = vm.pageAudio
                await vm.pausePageAudioAndMark()
                vm.setPageAudio(null)
                if (!paused) {
                    await vm.readCurrentText()
                    vm.closeReading()
                }
            }

            if (this.book.id && pageVoices !== newCurrentPage) {
                pageVoices = newCurrentPage
                await this.getAvailablesVoices(this.book.id, newCurrentPage);
            }
           
        },
        async book(newBook, oldBook) {
            const vm: any = this
            // Si cambió el libro, resetear el estado y cargar las voces para el nuevo libro
            if (newBook && newBook.id !== oldBook?.id) {
                // Pausar audio si está reproduciéndose
                if (vm.pageAudio) {
                    await vm.pausePageAudioAndMark()
                    vm.setPageAudio(null)
                }
                
                // Resetear la variable de control de página
                pageVoices = false
                
                // Cargar las voces disponibles para el nuevo libro
                if (newBook.id && vm.currentPage !== undefined) {
                    pageVoices = vm.currentPage
                    await this.getAvailablesVoices(newBook.id, vm.currentPage);
                }
            }
        },
        async challengePage(newCurrentPage) {
            const vm: any = this
            if (vm.pageAudio) {
                const {paused} = vm.pageAudio
                await vm.pausePageAudioAndMark()
                vm.setPageAudio(null)
                if (!paused) {
                    await vm.readCurrentText()
                    vm.closeReading()
                }
            }
            if (this.testId && pageVoices !== newCurrentPage) {
                pageVoices = newCurrentPage
                await this.getAvailablesVoicesForChallenges(this.testId);
            }
        },
        async testId(newTestId, oldTestId) {
            const vm: any = this
            // Si cambió el testId, resetear el estado y cargar las voces para el nuevo challenge
            if (newTestId && newTestId !== oldTestId) {
                // Pausar audio si está reproduciéndose
                if (vm.pageAudio) {
                    await vm.pausePageAudioAndMark()
                    vm.setPageAudio(null)
                }
                
                // Resetear la variable de control de página
                pageVoices = false
                
                // Cargar las voces disponibles para el nuevo challenge
                if (newTestId && vm.challengePage !== undefined) {
                    pageVoices = vm.challengePage
                    await this.getAvailablesVoicesForChallenges(newTestId);
                }
            }
        },
        currentVoice(newVoice, oldVoice) {
            const vm: any = this
            if (newVoice !== oldVoice && vm.pageAudio) vm.setPageAudio(null)
        },
    },
    methods: {
        ...mapActions('bookReading', ['setTrackIndex', 'showReadaloud', 'setActiveNarration', 'setPageAudio', 'setBookPageVoices', 'setCurrentVoice']),
        clearInterval() {
            const vm: any = this;
            clearInterval(vm.interval)
            this.mark()
        },
        getAudioMarksForChallenge() {
            const vm: any = this;
            return new Promise((resolve) => {
                fetch(
                    `${process.env.VUE_APP_READER_CHALLENGE_DATA_URL}challenge_${this.testId}/${vm.currentVoice || vm.defaultVoice}/challenge_${this.testId}_${this.challengePage}.json`
                )
                    .then((response) => {
                        response
                            .json()
                            .then(({marks}) => resolve(marks))
                            .catch(() => resolve(false))
                    })
                    .catch(() => resolve(false))
            })
        },
        getAudioMarksForBook() {
            const vm: any = this
            const {resourceDir} = this.book
            console.log('getAudioMarksForBook currentVoice', vm.currentVoice);
            return new Promise((resolve) => {
                fetch(
                    `${process.env.VUE_APP_READER_DATA_URL}${resourceDir}/${
                        vm.currentVoice || vm.defaultVoice
                    }/c_${vm.$utils.pad(vm.currentChapter, 2)}_${vm.currentPage}.json`
                )
                .then((response) => {
                    // Intentar parsear la respuesta como JSON primero
                    response
                      .json()
                      .then((data) => {
                        if (!data.marks) {
                          resolve(JSON.parse(data).marks);
                          return;
                        }
                        resolve(data.marks);
                      })
                      .catch(async () => {
                        // Si la respuesta no es un JSON válido, intentarlo como texto y luego parsear el texto como JSON
                        try {
                          const textResponse = await response.text();
                          const parsedJson = JSON.parse(textResponse);
                          resolve(parsedJson.marks);
                        } catch (error) {
                          resolve(false);
                        }
                      });
                  })
                .catch(() => resolve(false))
            })
        },
        async getAudioMarks() {
            let response = null;
            if (this.isBook) response = await this.getAudioMarksForBook()
            if (this.isChallenge) response = await this.getAudioMarksForChallenge()
            return Array.isArray(response) ? response : []
        },
        async getBookAudio() {
            const vm: any = this
            const { resourceDir } = vm.book
            try {
                if (!this.pageAudio)
                    return await new Audio(
                        `${
                            process.env.VUE_APP_READER_DATA_URL
                        }${resourceDir}/${vm.currentVoice || vm.defaultVoice}/c_${vm.$utils.pad(
                            vm.currentChapter,
                            2
                        )}_${vm.currentPage}.mp3`
                    )
                return null
            } catch (err) {
                return null
            }
        },
        async getChallengeAudio() {
            const vm: any = this
            try {
                if (!vm.pageAudio)
                    return await new Audio(
                        `${process.env.VUE_APP_READER_CHALLENGE_DATA_URL}challenge_${vm.testId}/${
                            vm.currentVoice || vm.defaultVoice
                        }/challenge_${vm.testId}_${vm.challengePage}.mp3`
                    )
                return null
            } catch (err) {
                return null
            }
        },
        async getPageAudio() {
            const vm: any = this
            try {
                if (!vm.pageAudio) {
                    if (vm.isBook) vm.setPageAudio(await vm.getBookAudio())
                    if (vm.isChallenge) vm.setPageAudio(await vm.getChallengeAudio())
                }

                vm.pageAudio.volume = vm.volume / 100
                vm.pageAudio.playbackRate = vm.rate

                vm.pageAudio.ontimeupdate = () => {
                    if (vm.pageAudio) vm.currentTime = (vm.pageAudio.currentTime * 1000).toFixed()
                }
            } catch (err) {
                // @ts-ignore
                vm.$modal.error(err.message)
            }
        },
        async pausePageAudio() {
            const vm: any = this
            if (this.pageAudio) await vm.pageAudio.pause()
        },
        async playPageAudio() {
            const vm: any = this
            if (this.pageAudio) await vm.pageAudio.play()
        },
        closeReading() {
            this.$emit('close-reading')
        },
        getPageContent() {
            const text = document.querySelector('.current-page')
            if (text) return text.textContent
            return ''
        },
        getTextFromElement(element: any) {
            let text = '';
            const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
            let node;
            while (node = walker.nextNode()) {
                // @ts-ignore
                text += node.textContent.trim() + '\n <br>';
            }
            return text.trim();
        },
        prepareTextArray() {
            const vm: any = this
            const text: any = document.querySelector('.current-page')
            if (text) {
                vm.instance = new Mark('.current-page')
                const textString = text.textContent.replaceAll(/(?:\r\n|\r|\n)/g, '/')
                vm.textArray = this.addStringTrack(textString.split(/[.,/]/))
                vm.pageTextAsArray = this.getTextFromElement(text).replaceAll('<br>', '').split(' ')
            }
        },
        generateChallengeAudio() {
            const vm: any = this
            return new Promise((resolve) => {
                vm.$utils
                    .postData(
                        `${process.env.VUE_APP_BEEREADERS_AUDIO_GENERATOR_URL}challenge/${vm.currentVoice || vm.defaultVoice}/${vm.testId}/${vm.challengePage}`,
                        {
                            text: vm.getPageContent(),
                        }
                    )
                    .then((response: any) => {
                        resolve(response)
                    })
                    .catch(() => {
                        resolve(false)
                    })
            })
        },
        generateBookAudio() {
            const vm: any = this
            return new Promise((resolve) => {
                const { resourceDir } = this.book
                vm.$utils
                    .postData(
                        `${
                            process.env.VUE_APP_BEEREADERS_AUDIO_GENERATOR_URL
                        }book/${vm.currentVoice || vm.defaultVoice}/${resourceDir}/${vm.$utils.pad(
                            vm.currentChapter,
                            2
                        )}/${vm.currentPage}`,
                        {
                            text: vm.getPageContent(),
                        }
                    )
                    .then((response: any) => {
                        resolve(response)
                    })
                    .catch(() => {
                        resolve(false)
                    })
            })
        },
        async callAudioGenerator() {
            let response: any | boolean = false
            if (this.isBook) response = await this.generateBookAudio()
            if (this.isChallenge) response = await this.generateChallengeAudio()
            return response && response.ok
        },
        async readCurrentText(showOrHideUtil: boolean = true) {
            const vm: any = this
            if (!vm.pageAudio) {
                vm.loading = true
                vm.prepareTextArray()
                vm.textMarks = await vm.getAudioMarks()
                if (!vm.textMarks.length) {
                    const res = await vm.callAudioGenerator()
                    if (!res) {
                        vm.loading = false
                        vm.snackbar = true
                        return
                    }
                    vm.textMarks = await vm.getAudioMarks()
                    vm.loading = false
                }

                await vm.getPageAudio()
                vm.loading = false
            }
            await vm.audioAction()
            if (showOrHideUtil) vm.showReadaloud()
        },
        async audioAction() {
            const vm: any = this
            if (vm.pageAudio && vm.pageAudio.paused) {
                await this.playPageAudio()
                this.setActiveNarration(true)
            } else {
                await this.pausePageAudioAndMark()
            }
        },
        async pausePageAudioAndMark() {
            await this.pausePageAudio()
            this.mark()
            this.setActiveNarration(false)
        },
        addStringTrack(textArray: Array<any>) {
            return [...textArray.filter((text) => text.trim().length)]
        },
        mark(text = ``) {
            const vm: any = this
            if (this.isBook){
                if (this.instance) vm.instance.unmark()
                if (text) {
                    const filter = (node: any, term: any, totalCounter: any) => {
                        return !(term === text && totalCounter > 1)
                    };
                    vm.instance.mark(text, {...configToMark, filter})
                }}
        },
        async removeChallengeAudio() {
            const vm: any = this
            await this.pausePageAudioAndMark()
            vm.setPageAudio(null)
        },
        async getAvailablesVoices(bookId: number, page: number): Promise<void> {
            const vm: any = this
            try {
                const response = await bookPageAudio.getVoices(bookId, page);
                vm.voices = response.slice(-2); // get only the last 2 voices available
                vm.setBookPageVoices(vm.voices.reverse());
                if (vm.voices.length > 0) {
                    // Set the last voice as the current voice
                    // @ts-ignore
                    const lastVoice = vm.voices[vm.voices.length - 1];
                    vm.setCurrentVoice(lastVoice.voice_provider_id);
                }
            } catch (error) {
                console.error('Error fetching voices:', error);  
            } finally {
                vm.loading = false; 
            }
        },
        async getAvailablesVoicesForChallenges(testId: number): Promise<void> {
            const vm: any = this
            try {
                const response = await challengePageAudio.getVoices(testId);
                vm.voices = response.slice(-2); // get only the last 2 voices available
                vm.setBookPageVoices(vm.voices.reverse());
                if (vm.voices.length > 0) {
                    // Set the last voice as the current voice
                    // @ts-ignore
                    const lastVoice = vm.voices[vm.voices.length - 1];
                    vm.setCurrentVoice(lastVoice.voice_provider_id);
                }
            } catch (error) {
                console.error('Error fetching voices:', error);  
            } finally {
                vm.loading = false;
            }
        }
    },
    mounted() {
        this.isBook = this.$route.path.includes('book')
        this.isChallenge = this.$route.path.includes('challenge') || this.$route.path.includes('tester')
        
        // Cargar las voces disponibles cuando se monta el componente
        this.$nextTick(async () => {
            if (this.isBook && this.book && this.book.id) {
                pageVoices = this.currentPage
                await this.getAvailablesVoices(this.book.id, this.currentPage);
            }
            if (this.isChallenge && this.testId) {
                pageVoices = this.challengePage
                await this.getAvailablesVoicesForChallenges(this.testId);
            }
        })
    },

    async beforeDestroy() {
        await this.pausePageAudioAndMark()
    },
})

export default markJs
